export default __webpack_public_path__ + "assets/cart-outline.4fee9029.webp";